import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import PropTypes from "prop-types";
import { ReactComponent as LogoBlack } from "../../assets/images/landing/logo/logo-black.svg";
import AuthHelper from "../../utils/AuthHelper";
import RoseButton from "../common/RoseButton";
import {
  menuItemClickLandingPageGTM,
  sendCtaClickLandingPageGTM,
} from "../../utils/TagManagerHelper";

function LandingHeader({ isScroll, faqRef, demoRef }) {
  const [notAtTop, setNotAtTop] = useState(false);
  const [hideHeader, setHideHeader] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(window.scrollY);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const onResize = () => {
      setIsTablet(window.innerWidth <= 991);
    };

    window.addEventListener("resize", onResize);
    onResize();
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [isTablet]);

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;
    const visible = currentScrollPos > 100 ? !isScroll && prevScrollPos < currentScrollPos : false;

    setPrevScrollPos(currentScrollPos);
    setHideHeader(visible);
    setNotAtTop(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const handleLogin = () => {
    AuthHelper.login();
    sendCtaClickLandingPageGTM("Log in");
  };

  const handleNavigate = (ref, label) => {
    ref.current.scrollIntoView({ behavior: "instant" });
    menuItemClickLandingPageGTM(label);
  };

  return (
    <div className={classnames("landing-header", { hideHeader }, { notAtTop })}>
      <div className="logo-wrap">
        <div className="logo my-auto">
          <a href="/">
            <LogoBlack />
          </a>
        </div>
        <span className="logo-links">
          <Link
            onClick={() => handleNavigate(faqRef, "FAQs")}
            to="/#"
            className="p2 medium-contrast my-auto"
          >
            FAQs
          </Link>
          <Link
            onClick={() => handleNavigate(demoRef, "Request a demo")}
            to="/#"
            className="p2 medium-contrast my-auto demo-link"
          >
            Request a demo
          </Link>
        </span>
      </div>
      <div className="landing-btn ">
        <p className="head-cta footer-voices medium-contrast my-auto">
          Do you already have an account?
        </p>

        <RoseButton
          className={classnames("outline-dark", { "btn cta-mini": !isTablet })}
          onClick={handleLogin}
        >
          Log in
        </RoseButton>
      </div>
    </div>
  );
}

LandingHeader.propTypes = {
  isScroll: PropTypes.bool,
  demoRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  faqRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};

LandingHeader.defaultProps = {
  isScroll: false,
};

export default LandingHeader;
